module.exports = __webpack_public_path__ + "img/logoinverso.8729674b.png";